import user from '@/router/middleware/user.js'
import AdminLayout from '@/Layouts/AdminLayout'
import AuthLayout from '@/Layouts/AuthLayout.vue'

export default [
  {
    path: '/rider/signup',
    name: 'Rider SignUp',
    component: () => import(/* webpackChunkName: "signUpRider" */'@/views/Site/Authentication/signUpRider'),
    meta: {
      layout: AuthLayout,
      title: 'Rider Sign Up'
    }
  },
  {
    path: '/rider/profile',
    name: 'riderProfile',
    component: () => import(/* webpackChunkName: "createShop" */ '@/views/Admin/riders/Profile/profile'),
    beforeEnter: user,
    meta: {
      layout: AdminLayout,
      title: 'Profile'
    }
  },
  {
    path: '/rider/completed-rides',
    name: 'Completedride',
    component: () => import(/* webpackChunkName: "createShop" */ '@/views/Admin/riders/CompletedRide/completed.vue'),
    beforeEnter: user,
    meta: {
      layout: AdminLayout,
      title: 'Completed Rides'
    }
  }
]
